export default function withQueryClient(Component) {
    return (props) => (
        <ReactQuery.QueryClientProvider client={window.queryClient}>
            <Component {...props} />
        </ReactQuery.QueryClientProvider>
    )
}
